<template>
  <div />
</template>

<script>
/**
 * Vue: Content card slider (content-card-slider)
 * -----------------------------------------------------------------------------
 * Content card slider.
 * - Limited interactivity section.
 *
 * @param {String} liquid.blockLength - Section's block length.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import { Splide } from '@splidejs/splide';

import { values as breakpoints } from '~/config/breakpoints';

export default {
  name: 'ContentCardSlider',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        blockLength: 0,
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      carousel: null,
    };
  },

  mounted() {
    if (this.carousel) {
      return;
    }

    const selector = `#vue-element [js-content-card-slider="${this.liquid.sectionId}"]`;
    this.constructCarousel(selector);
  },

  methods: {
    /**
     * Construct and mount the carousel.
     * @param {HTMLElement} selector - Carousel selector.
     */
    async constructCarousel(selector) {
      if (!selector) {
        return;
      }

      this.carousel = new Splide(selector, {
        arrows: false,
        focus: 0,
        gap: 'var(--layout-gutter)',
        mediaQuery: 'min',
        keyboard: true,
        omitEnd: true,
        paginationKeyboard: true,
        padding: {
          left: 'var(--layout-margin)',
          right: 'var(--layout-margin)',
        },
        pagination: true,
        perPage: 1,
        breakpoints: {
          [breakpoints.m]: {
            perPage: 2,
          },
          [breakpoints.l]: {
            arrows: true,
            drag: false,
            pagination: false,
            padding: 0,
            perPage: 3,
          },
        },
      });

      await this.$nextTick();
      this.carousel.mount();
    },
  },
};
</script>

<style lang="scss">
@import './content-card-slider';
</style>
